import * as React from 'react';
import { useContext } from 'react';

import type { ENTERPRISE_MODAL_NAMES } from 'bundles/unified-common/constants/enterprise';
import type { ProgramJoinErrorModalInfo } from 'bundles/unified-common/types/enterprise';

export type EnterpriseModalManagerContextType = {
  modalToShow?: (typeof ENTERPRISE_MODAL_NAMES)[keyof typeof ENTERPRISE_MODAL_NAMES] | null;
  isAccessModalDismissed: boolean;
  setIsAccessModalDismissed: (argo0: boolean) => void;
  isAutoenrolledCoursesModalDismissed: boolean;
  setIsAutoenrolledCoursesModalDismissed: (arg0: boolean) => void;
  setHasShownLoginModal: (arg0: boolean) => void;
  showEnterpriseTermsOfUseModal: boolean;
  setShowEnterpriseTermsOfUseModal: React.Dispatch<React.SetStateAction<boolean>>;
  programJoinErrorInfo: ProgramJoinErrorModalInfo;
  setProgramJoinErrorInfo: React.Dispatch<React.SetStateAction<ProgramJoinErrorModalInfo>>;
  isLoading: boolean;
  isEnterpriseAdmin: boolean;
  shouldShowCCPAMarketingConsent: boolean;
  shouldShowGDPRMarketingConsent: boolean;
  shouldShowThirdPartyTermsOfConsent: boolean;
};

const EnterpriseModalManagerContext = React.createContext<EnterpriseModalManagerContextType | undefined>(undefined);

export const useEnterpriseModalManager = () => {
  const modalManager = useContext(EnterpriseModalManagerContext);

  return modalManager;
};

export default EnterpriseModalManagerContext;
